@app.controller 'SSOController', (currentUser, $location, ssoService, $scope) ->
  @state = $location.search().state
  @token = $location.search().token
  @showForm = false
  @ssoService = ssoService
  $scope.currentUser = currentUser

  if currentUser && !ssoService.isAmazon() && !@token
    ssoService.signAndRedirect(@state)

  else if @token # /sso?token=SOMETOKEN
    redirect = $location.search().path
    if currentUser
      ssoService.redirectOrRoot(redirect)
    else
      ssoService.signAndUpgradeToken(@token,redirect)

  else
    @showForm = true

  this
